import creator 	     			      from './colorz/utils/creator';
import PopinManager             from './colorz/core/Popin/PopinManager';
import ImageCoverWrapper 		    from './colorz/core/ImageCover/ImageCoverWrapper';

import PlayerYoutube 			      from './components/PlayerYoutube';
import Cookie 					        from './components/Cookie';
import KeyDates 				        from './components/KeyDates';
import Collapse 				        from './components/Collapse';
import ExpertiseSliderPhotos 	  from './components/ExpertiseSliderPhotos';
import HomepageFPLiveSlider 	  from './components/HomepageFPLiveSlider';
import MobileMenu 				      from './components/MobileMenu';
import KnowledgeClassicSlider 	from './components/KnowledgeClassicSlider';
import CollectionsClassicSlider from './components/CollectionsClassicSlider';
import HairstyleTabs 			      from './components/HairstyleTabs';
import RealSlider 				      from './components/RealSlider';
import Newsletter 				      from './components/Newsletter';
import Input 					          from './components/Input';
import FPlive 					        from './components/FPlive';
import VideosPatchwork 			    from './components/VideosPatchwork';
import FpliveTabs 				      from './components/FpliveTabs';
import FakeSelect 				      from './components/FakeSelect';
import AttachFile 				      from './components/AttachFile';
import Loadmore 				        from './components/Loadmore';
import Menu 					          from './components/Menu';
import Gallery 					        from './components/Gallery';
import Lightbox 				        from './components/Lightbox';
import PopinInputs              from './components/PopinInputs';
import Loader                   from './components/Loader';
import FadeIn 					        from './components/animations/FadeIn';
import Counter 					        from './components/animations/Counter';

import browserDetect            from './utils/BrowserDetect';

window.browser                  = browserDetect();
window.popinManager             = new PopinManager();
window.youtubePlayers			      = creator( '.js-player-yt', PlayerYoutube );
window.cookieBanner				      = creator( '.js-cookie-banner', Cookie );
window.keyDatesSlideshow		    = creator( '.js-keydates', KeyDates );
window.expertiseSlider			    = creator('.js-expertise-slider-photos', ExpertiseSliderPhotos);
window.homepageSlider			      = creator('.js-homepage-fplive-slider', HomepageFPLiveSlider);
window.mobileMenu				        = creator('.js-header', MobileMenu);
window.knowledgeClassicSlider	  = creator('.js-slider-knowledge', KnowledgeClassicSlider);
window.collectionsClassicSlider	= creator('.js-slider-collections', CollectionsClassicSlider);
window.hairstyleTabs			      = creator('.js-hairstyle-tabs', HairstyleTabs);
window.fplive					          = creator('.js-fplive-slider', FPlive);
window.fpliveTabs				        = creator('.js-tabs', FpliveTabs);
window.loadmore					        = creator('.js-loadmore', Loadmore);
window.menu						          = creator('.js-header', Menu);
window.gallery					        = creator('.js-gallery', Gallery);
window.imageCovers 				      = creator('.js-image-cover-wrapper', ImageCoverWrapper );
window.fadeIn					          = creator('.js-fade-in', FadeIn);
window.counter					        = creator('.js-counter', Counter);
window.popinInputs              = creator('#nl_popin', PopinInputs);
window.loader                   = creator('.js-loader', Loader);

window.lightbox = document.querySelectorAll('.js-lightbox');
for (var i = 0; i < window.lightbox.length; i++) {
  creator('.js-box', Lightbox, {parent: window.lightbox[i]}, window.lightbox[i]);
}

window.videosPatchwork = document.querySelectorAll('.js-videos');
for (var i = 0; i < window.videosPatchwork.length; i++) {
  creator('.js-single-video', VideosPatchwork, {parent: window.videosPatchwork[i]}, window.videosPatchwork[i]);
}

window.newsletter = document.querySelectorAll('.js-form');
for (var i = 0; i < window.newsletter.length; i++) {
  creator('.js-inputs', Newsletter, {parent: window.newsletter[i]}, window.newsletter[i]);
}

window.input = document.querySelectorAll('.js-multi-form');
for (var i = 0; i < window.input.length; i++) {
  creator('.js-classic-form', Input, {parent: window.input[i]}, window.input[i]);
  creator('.js-dropdown', FakeSelect, {parent: window.input[i]}, window.input[i]);
  creator('.js-attach-file', AttachFile, {parent: window.input[i]}, window.input[i])
}

window.realslider = document.querySelectorAll('.js-real-slider');
for (var i = 0; i < window.realslider.length; i++) {
  creator('.js-slides', RealSlider, {parent: window.realslider[i]}, window.realslider[i]);
}

window.collapses = document.querySelectorAll('.js-collapse');
window.collapsesItem = new Array();

for( let i = 0 ; i < window.collapses.length ; i++ ) {
  window.collapsesItem = window.collapsesItem.concat( creator( '.js-item', Collapse, {parent: window.collapses[i]}, window.collapses[i] ) );
}

setTimeout( ()=> {
	if( window.collapsesItem.length )
		window.collapsesItem[0].onOpen();
}, 1000)


